import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'
import { useTopPartnerId } from 'legacy/lut/hooks/useTopPartnerId'
import { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'

import { getUrlParam } from 'core-components/helpers/url'
import { selectUser } from 'core-components/sitebuilder/store/selectors/selectUser'
import { Logic, Operator } from 'core-components/types'
import { Crud } from 'core/types/Crud'
import { CrudStore } from 'core/types/crudStore'

import { INITIAL_CONJUNCTION_FILTER, PAGE_CONFIG } from '../../../../configs'
import { getDecoratedFetchFn } from '../../../../helpers/getDecoratedFetchFn'
import { IContactTab } from '../../../../models'

interface IUseProfilingTeamRequestSource extends Partial<IContactTab> {}

export function useProfilingTeamRequestSource({
  partnerId = '',
  onAfterFetch,
  onBeforeFetch,
  onCatchError,
}: IUseProfilingTeamRequestSource) {
  const [source, setSource] = useState<Crud>()
  const { topPartnerId } = useTopPartnerId(partnerId)
  const { email } = useSelector(selectUser)

  const isBPType = useMemo(() => {
    return getUrlParam('type') === 'bp-registration'
  }, [])

  useEffect(() => {
    const crud = CrudStore.get(
      CrudStoreItem.OpenedContactRequests,
      `partnerContacts-profilingTeamRequestList-${partnerId}`
    )
    // const originalFetchFn = crud.fetch.bind(crud)
    const defaultFilterField = isBPType ? 'TopPartnerID' : 'PartnerID'
    const defaultFilterValue = isBPType ? topPartnerId : partnerId

    crud.setDefaultFilter({
      logic: Logic.AND,
      filters: [
        {
          field: defaultFilterField,
          operator: Operator.EQUAL,
          value: defaultFilterValue,
        },
        {
          field: 'ModifiedBy',
          operator: Operator.EQUAL,
          value: email,
        },
      ],
    })

    crud.setFilter({
      logic: Logic.AND,
      filters: [
        {
          field: 'ModifiedBy',
          operator: Operator.EQUAL,
          value: email,
        },
      ],
    })

    crud.setFilter(INITIAL_CONJUNCTION_FILTER)

    crud.setSort([
      {
        dir: 'desc',
        field: 'IsKeyContact',
      },
      {
        field: 'LastName',
        dir: 'asc',
      },
    ])

    crud.setPaging(PAGE_CONFIG)

    setSource(crud)
  }, [email, isBPType, onAfterFetch, onBeforeFetch, onCatchError, partnerId, topPartnerId])

  return { source }
}
